import React from "react";
import {
  ResponsiveContainer,
  Bar,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";

const TransferDistrictRequestsChart = ({ data }) => {
  if (!data) return null;

  const sortedData = [...data].sort(
    (a, b) => b.requests_from - a.requests_from
  );

  return (
    <ResponsiveContainer
      width="100%"
      height={1300}
      style={{ display: "flex", justifyContent: "flex-start" }}
    >
      <BarChart
        data={sortedData}
        layout="vertical"
        margin={{ top: 10, right: 80, left: -30, bottom: 10 }}
        barGap={0}
        barCategoryGap={24}
      >
        <CartesianGrid strokeDasharray="3 3" horizontal={false} />
        <XAxis type="number" />
        <YAxis
          type="category"
          dataKey="name"
          width={150}
          orientation="left"
          tick={{ textAnchor: "start", dx: -95 }}
        />
        <Tooltip formatter={(value, name) => [value.toLocaleString(), name]} />
        <Legend />
        <Bar
          dataKey="requests_from"
          fill="hsl(var(--chart-1))"
          name="Requests From"
          barSize={16}
        >
          <LabelList
            dataKey="requests_from"
            position="right"
            formatter={(value) => value.toLocaleString()}
            style={{
              fontWeight: "bold",
              fontSize: 14,
              fill: "black",
            }}
          />
        </Bar>
        <Bar
          dataKey="requests_to"
          fill="hsl(var(--chart-2))"
          name="Requests To"
          barSize={16}
        >
          <LabelList
            dataKey="requests_to"
            position="right"
            formatter={(value) => value.toLocaleString()}
            style={{
              fontWeight: "bold",
              fontSize: 14,
              fill: "black",
            }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TransferDistrictRequestsChart;
